import React, { useState } from 'react';
import Modal from '../Modal';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import commonActions from '../../Actions/commonActions';
import useCustomerNavigation from "../../Hooks/Customer/useCustomerNavigation";

function EditShortcutsModal({ t, commonActions, userShortcuts, onClose }) {
    const { categorizedItems, navigationItems, } = useCustomerNavigation();
    const categorizedShortcuts = categorizedItems();
    const shortcuts = navigationItems();
    const [selectedShortcuts, setSelectedShortcuts] = useState(userShortcuts.filter(shortcut => Object.values(shortcuts)?.find(x => x.id === shortcut)))

    const modalProps = {
        title: t('editshortcutsmodal.editshortcuts'),
        mainButtonTitle: t('editshortcutsmodal.save'),
        onCancelClick: onClose,
        stateful: true,
        open: true,
        onSaveClick: () => {
            commonActions.modifyShortcuts(selectedShortcuts)
            onClose();
            window.location.reload()
        },
        customClassName: 'modal-xl',
    };
    const addToUserShortcuts = (shortcut) => {
        setSelectedShortcuts([...selectedShortcuts, shortcut.id]);
    };

    const removeFromUserShortcuts = (shortcut) => {
        setSelectedShortcuts(selectedShortcuts.filter(s => s !== shortcut));
    };
    

    return (
        <Modal {...modalProps}>
            <div style={{maxHeight: "500px", overflowY: "scroll"}}>
                <div className='d-flex justify-content-between'>
                <div className='col-6'>
                    <h2 className='text-center'>{t('editshortcutsmodal.availableshortcuts')}</h2>
                    <div className='d-flex flex-column' style={{gap: "15px"}}>
                        {categorizedShortcuts.map((item) => (
                            <div key={item.link.label}>
                                <h3 className='bold'>{item.link.label}</h3>
                                {item.link.subItems?.map((subItem, shortcutIndex) => (
                                    <button className="btn btn-default w-100" disabled={selectedShortcuts.includes(subItem.link.id)} key={subItem.link.title} onClick={() => addToUserShortcuts(subItem.link)}>{subItem.link.label}</button>
                                ))}
                                {!item.link.subItems && <button className="btn btn-default w-100" disabled={selectedShortcuts.includes(item.link.id)} onClick={() => addToUserShortcuts(item.link)}>{item.link.label}</button>}
                            </div>
                        ))}
                    </div>
                    </div>
                    <div className='col'>
                        <h2 className='text-center mb-48'>{t('editshortcutsmodal.selectedshortcuts')}</h2>
                        {selectedShortcuts.map((shortcut, index) => (
                            <button className='btn btn-default w-100' key={shortcut} onClick={() => removeFromUserShortcuts(shortcut)}>{t(Object.values(shortcuts).find(x => x.id === shortcut).title)}</button>
                        ))}
                    </div>
                   
                </div>
            </div>
        </Modal>
    );
}

function mapStateToProps(state) {
    return {
        userShortcuts: state.CommonReducer.userShortcuts
    };
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditShortcutsModal));